<template>
  <div></div>
</template>
<script>
import { getPinkInfoAndUserInfo } from './query.gql'
export default {
  name: 'groupShare',
  data() {
    return {
      pink: '',
      user: ''
    }
  },
  async mounted() {
    console.log('分享页')
    const { id } = this.$route.params
    if (!id) {
      this.$toast.fail('无拼团信息')
      this.$router.back(-1)
    }
    await this.weixinAuth()
    this.wechatPay()
    this.loadInformations() // 获取拼团信息
  },
  methods: {
    loadInformations() {
      const self = this
      self.$toast.loading({
        mask: true,
        duration: 0,
        message: '加载中'
      })
      self.loadPinkInfo(self.$route.params.id).then(res => {
        console.log('拼团信息', res)
        self.pink = res.data.pink
        self.user = res.data.profile
        self.$toast.clear()
        // 关于拼团
        // 1、课程详情页拼团下单支付后 --> 拼团邀请页 --> 发起分享
        // 2、我的课堂（邀请好友）--> 拼团邀请页 --> 发起分享
        // 3、拼团分享页 分享团id=1已参与该团id=1 分享团进行中 pink.status == ongoing && pink.isJoin --> 拼团邀请页 --> 发起分享
        // 4、拼团分享页 分享团id=1已参与该团id=1 分享团已失败 pink.status == fail --> 拼团失败页 --> 显示按钮全价购和拼团按钮
        // 5、拼团分享页 分享团id=1已参与该团id=1 分享团已成功 pink.status == success --> 拼团成功页 --> 点击观看课程

        // 6、拼团分享页 分享团id=1已参与该团id=2 参与团进行中 --> 参与团邀请页 --> 发起分享
        // 7、拼团分享页 分享团id=1已参与该团id=2 参与团已成功 --> 参与团成功页 --> 点击观看课程
        // 8、拼团分享页 分享团id=1已参与该团id=2 参与团已失败 分享团进行中 --> 分享团进行页
        // 9、拼团分享页 分享团id=1已参与该团id=2 参与团已失败 分享团成功 --> 分享团成功页（该课已拼团成功，自己开团试试吧！）
        // 10、拼团分享页 分享团id=1已参与该团id=2 参与团已失败 分享团失败 --> 分享团失败页 --> 显示按钮全价购和拼团按钮

        // 9、拼团分享页 分享团id=1用户未参与该团 分享团进行中 pink.status == ongoing && !pink.isJoin --> 分享团进行页
        // 10、拼团分享页 分享团id=1用户未参与该团 分享团已成功 pink.status == success && !pink.isJoin --> 分享团成功页（该课已拼团成功，自己开团试试吧！）
        // 11、拼团分享页 分享团id=1用户未参与该团 分享团已失败 pink.status == fail && !pink.isJoin --> 分享团失败页 --> 显示按钮全价购和拼团按钮

        // 12、拼团进行页 拼团支付后满团 --> 拼团成功页 --> 点击观看课程
        // 13、拼团进行页 拼团支付后未满团 --> 拼团邀请页 --> 发起分享
        // 14、拼团进行页 拼团倒计时结束 --> 拼团失败页 --> 显示按钮全价购和拼团按钮

        let redirectUrl = ''
        let redirectId = ''
        if (self.user.isDistributor) {
          self.$router.replace({
            name: 'subject',
            query: { id: self.pink.subject.id }
          })
        } else {
          if (self.pink.subject.orderInfo) {
            switch (self.pink.subject.orderInfo.types) {
              case 'full_buy':
                self.$router.replace({
                  name: 'classroom'
                })
                break
              case 'pink_buy':
                if (self.pink.isJoin) {
                  // 分享团与参与团相同
                  redirectId = self.pink.id
                  switch (self.pink.status) {
                    case 'ongoing':
                      redirectUrl = 'groupInvite'
                      break
                    case 'success':
                      redirectUrl = 'groupSuccess'
                      break
                    case 'fail':
                      redirectUrl = 'groupFail'
                      break
                  }
                } else {
                  // 分享团与参与团不同
                  redirectId = self.pink.subject.pinkInfo.id
                  switch (self.pink.subject.pinkInfo.status) {
                    case 'ongoing':
                      redirectUrl = 'groupInvite'
                      break
                    case 'success':
                      redirectUrl = 'groupSuccess'
                      break
                    case 'fail':
                      redirectId = self.pink.id
                      if (self.pink.status === 'ongoing') {
                        redirectUrl = 'group'
                      } else if (self.pink.status === 'success') {
                        redirectUrl = 'groupSuccess'
                      } else if (self.pink.status === 'fail') {
                        redirectUrl = 'groupFail'
                      }
                      break
                  }
                }
                self.$router.replace({
                  name: redirectUrl,
                  params: { id: redirectId }
                })
                break
              case 'invite_buy':
                self.$router.replace({
                  name: 'invite',
                  params: { id: self.pink.subject.id },
                  query: {
                    invitationCode: self.pink.subject.orderInfo.parentUser.invitationCode
                  }
                })
                break
              case 'distribute_buy':
                self.$router.replace({
                  name: 'subject',
                  query: { id: self.pink.subject.id }
                })
                break
            }
          } else {
            // 用户未参与该团
            redirectId = self.pink.id
            switch (self.pink.status) {
              case 'ongoing':
                redirectUrl = 'group'
                break
              case 'success':
                redirectUrl = 'groupSuccess'
                break
              case 'fail':
                redirectUrl = 'groupFail'
                break
            }
            self.$router.replace({
              name: redirectUrl,
              params: { id: redirectId }
            })
          }
        }
      }).catch(err => {
        console.error('page: group/share。请求getPinkInfoAndUserInfo报错', err)
        self.$toast.clear()
      })
    },
    loadPinkInfo(id) {
      return this.$apollo.query({
        query: getPinkInfoAndUserInfo,
        variables: {
          id: parseInt(id)
        }
      })
    }
  }
}
</script>
<style lang="scss" scoped>

</style>
